import React from "react";
import { Box, Pagination, PaginationItem } from "@mui/material";
import { useSelector } from "react-redux";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

/**
 * Brand-aligned pagination (E&J pink–purple, 5px radius).
 */
const BrandPagination = ({
  count,
  page,
  onChange,
  siblingCount = 1,
  boundaryCount = 1,
  showLabels = false,
}) => {
  const theme = useSelector((state) => state.themeValue?.colors) || {};
  const start = theme.primary_gradient_start_color || "#FF2D95";
  const end = theme.primary_gradient_end_color || "#7B1FA2";

  if (!count || count <= 1) return null;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mt: 4,
        mb: 2,
        px: 1,
      }}
    >
      <Pagination
        count={count}
        page={page}
        onChange={onChange}
        siblingCount={siblingCount}
        boundaryCount={boundaryCount}
        shape="rounded"
        renderItem={(item) => (
          <PaginationItem
            slots={{
              previous: showLabels
                ? () => (
                    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, px: 0.5 }}>
                      <ArrowBackIosNewIcon sx={{ fontSize: 12 }} />
                      Prev
                    </Box>
                  )
                : ArrowBackIosNewIcon,
              next: showLabels
                ? () => (
                    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, px: 0.5 }}>
                      Next
                      <ArrowForwardIosIcon sx={{ fontSize: 12 }} />
                    </Box>
                  )
                : ArrowForwardIosIcon,
            }}
            {...item}
            sx={{
              mx: 0.35,
              minWidth: item.type === "previous" || item.type === "next"
                ? showLabels ? 72 : 36
                : 36,
              height: 36,
              borderRadius: "5px",
              fontWeight: 600,
              fontSize: 14,
              color: theme.text || "#333",
              border: "1px solid #e8edf5",
              bgcolor: "#fff",
              transition: "all 0.2s ease",
              "&.Mui-selected": {
                background: `linear-gradient(90deg, ${start}, ${end})`,
                color: "#fff !important",
                borderColor: "transparent",
                boxShadow: `0 4px 12px ${start}40`,
                "&:hover": {
                  background: `linear-gradient(90deg, ${end}, ${start})`,
                },
              },
              "&:hover": {
                bgcolor: `${start}12`,
                borderColor: start,
              },
              "&.Mui-disabled": {
                opacity: 0.4,
                borderColor: "#eee",
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default BrandPagination;
